// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__9hRYo mds-typography-legacy-body-100","cookieManager":"styles_cookieManager__2TB_V","mock-focus":"styles_mock-focus__TO69T"};